var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX2 = function SvgX2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F7F8FA",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.654 5.95a.6.6 0 0 1 .849.847L13.298 12l5.205 5.205a.6.6 0 0 1-.849.849L12.45 12.85l-5.204 5.205a.6.6 0 1 1-.848-.849l5.204-5.205-5.204-5.204a.6.6 0 1 1 .848-.848l5.204 5.204z"
  })));
};
export default SvgX2;